import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../apis"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select"
import {
  FaCheck,
  FaClipboardList,
  FaEye,
  FaFilePdf,
  FaTimes,
} from "react-icons/fa"
import FileDownload from "js-file-download"
import demo from "../../assets/videos/demoEtud.mp4"
const AddOrientation = props => {
  const [array, setArray] = useState([])
  const [specialite, setSpecialite] = useState([])
  const [selectSpecilaite, setSelectSpecilaite] = useState("")
  var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
  var annee_id = userAuthEtudiant.user.annee_id
  var user_id = userAuthEtudiant.user.id
  var etudiant_id = userAuthEtudiant.user.id_etudiant
  var specialite_id = userAuthEtudiant.user.specialite_id
  var etat_orientation = userAuthEtudiant.user.etat_orientation
  const [order, setOrder] = useState([])
  const [etat, setEtat] = useState(null)
  const [tiles, setTiles] = useState([])
  const [moyenneGenerale, setMoyenneGenerale] = useState("")
  const [session, setSession] = useState("")
  const [matieres, setMatieres] = useState("")
  const save = async () => {
      API.post("candidature_orientation/submit", {
        annee_id,
        etudiant_id,
        specialite_source_id: specialite_id,
        array,
      }).then(res => {
        toast.success(" 🔓✔️ Orientation ajoutée Avec succès", {
          containerId: "A",
        })
        props.setSection(2)
      })
  }

  const downloadFile = async (id, titre) => {
    try {
      const res = await API.post(
        "orientation/avis/download",
        { id, annee_id: annee_id },
        { responseType: "blob" }
      )
      FileDownload(res.data, `${titre}.pdf`)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(async () => {
    const resSpec = await API.post(
      "candidature_orientation/calculer_score_etudiant",
      {
        annee_id,
        etudiant_id,
        specialite_source_id: specialite_id,
      }
    ).then(resSpec => {
      setArray(resSpec.data.Scores.scores)
      if (resSpec.data.Scores.scores.length > 0) {
        const generatedOrder = Array.from(
          { length: resSpec.data.Scores.scores.length },
          (_, i) => ({
            value: i + 1,
            label: (i + 1).toString(),
          })
        )
        setMoyenneGenerale(resSpec.data.Scores.moyenne_generale)
        setSession(resSpec.data.Scores.session)
        setMatieres(resSpec.data.Scores.matieres)
        setOrder(generatedOrder)
      }
    })
    // Récupérer la liste des avis
    API.post("orientation/avis/list", { annee_id,specialite_id }).then(res => {
      const staticTiles = []
      const apiTiles =
        res.data.avis?.map(item => ({
          title: item.titre,
          icon: <FaFilePdf />,
          iconCheck: <FaCheck />,
          color: "#da0e0e",
          download: "telecharger",
          name: "Télécharger",
          iconCheck2: <FaFilePdf />,
          id: item.id,
        })) || [] // <-- fallback si res.data.avis est undefined

      setTiles([...staticTiles, ...apiTiles])
    })
  }, [])
  const handleOrderChange = (index, selectedOption) => {
    const newArray = [...array]
    newArray[index].ordre_preference = selectedOption
    setArray(newArray)
  }
  const getAvailableOptions = currentIndex => {
    const selectedValues = array
      .map(item => item.ordre_preference?.value)
      .filter(Boolean)

    return order.filter(opt => {
      // garder la valeur actuelle de la ligne
      if (array[currentIndex].ordre_preference?.value === opt.value) return true

      // exclure les valeurs déjà utilisées
      return !selectedValues.includes(opt.value)
    })
  }
  const toggleDetail = (type = null, id = null, name = null) => {
    if (type === "url") {
      props.history.push("/Orientation")
    } else {
      downloadFile(id, name)
    }
  }
  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            {/*{etat === 1 && etat_orientation === 1 ? (*/}
            <Row>
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: "25px",
                  padding: "10px",
                }}
              >
                {tiles.map((tile, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: tile.color,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      borderRadius: "10px",
                      cursor: "pointer",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      transition: "transform 0.3s, box-shadow 0.3s",
                      color: "#fff",
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = "scale(1.05)"
                      e.currentTarget.style.boxShadow =
                        "0 10px 20px rgba(0,0,0,0.3)"
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = "scale(1)"
                      e.currentTarget.style.boxShadow =
                        "0 4px 8px rgba(0,0,0,0.2)"
                    }}
                  >
                    <div
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                          width: "70px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 15px auto",
                        }}
                      >
                        {React.cloneElement(tile.icon, {
                          size: 35,
                          color: tile.color,
                        })}
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        {tile.title}
                      </div>
                    </div>

                    {/* Actions */}
                    <div
                      style={{
                        backgroundColor: "#fff",
                        padding: "8px",
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        borderTop: `2px solid ${tile.color}`,
                      }}
                    >
                      <a
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px 10px",
                          border: `1px solid ${tile.color}`,
                          borderRadius: "5px",
                          color: tile.color,
                          fontWeight: "bold",
                          textDecoration: "none",
                          gap: "11px",
                          transition: "0.3s",
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.backgroundColor = tile.color
                          e.currentTarget.style.color = "#fff"
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.backgroundColor = "#fff"
                          e.currentTarget.style.color = tile.color
                        }}
                        onClick={() =>
                          toggleDetail(tile.download, tile.id, tile.title)
                        }
                      >
                        {tile.iconCheck2 &&
                          React.cloneElement(tile.iconCheck2, {
                            style: {
                              fontSize: "20px",
                              color: "inherit",
                            },
                          })}
                        {tile.name}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </Row>
            {/*) : null}*/}
            <Row>
              <Table className="mt-3" striped bordered hover>
                <tbody>
                  {/* Ligne Moyenne Générale */}
                  <tr>
                    <th width="30%">Moyenne générale</th>
                    <td colSpan="3">{moyenneGenerale}</td>
                  </tr>

                  {/* Ligne Session */}
                  <tr>
                    <th>Session</th>
                    <td colSpan="3">{session}</td>
                  </tr>

                  {/* Ligne Matières */}
                  <tr>
                    <th>Matières prises en compte</th>
                    <td
                      colSpan="3"
                      dangerouslySetInnerHTML={{ __html: matieres }}
                    />
                  </tr>

                  {/* Entête des spécialités */}
                  <tr>
                    {etat === 1 && etat_orientation === 1 ? (
                      <th style={{ textAlign: "center" }}>Ordre</th>
                    ) : (
                      <th style={{ textAlign: "center" }}>Résultat</th>
                    )}
                    <th style={{ textAlign: "center" }}>Spécialité</th>
                    <th style={{ textAlign: "center" }}>Score</th>
                  </tr>

                  {/* Liste des spécialités */}
                  {array.map((specialite, index) => (
                    <tr key={index}>
                      <td style={{ width: "200px" }}>
                        {etat === 1 && etat_orientation === 1 ? (
                        <Select
                          options={getAvailableOptions(index)}
                          isSearchable
                          isClearable
                          value={specialite.ordre_preference || null}
                          onChange={e => handleOrderChange(index, e)}
                        />
                        ):(
                          specialite.resultat
                        )
                        }
                      </td>
                      <td>{specialite.specialite_destination_name}</td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.score_final}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Row>
          </Form>
          {etat === 1 && etat_orientation === 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
            ):null}
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddOrientation)
AddOrientation.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
